import { render, staticRenderFns } from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=template&id=ed45ab1a&scoped=true"
import script from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=style&index=0&id=ed45ab1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed45ab1a",
  null
  
)

export default component.exports